import React from "react";

/**
 * ClientDesk VA logo — always sourced from the approved master in /brand/.
 *
 * Master files (never overwritten):
 *   /brand/icon.svg                     · 1024 square, deep-green field
 *   /brand/logo-horizontal-dark.svg     · icon + ClientDesk VA + Virtual Assistant Workspace (dark)
 *   /brand/logo-horizontal-light.svg    · same lock-up on light
 *   /brand/logo-compact-dark.svg        · icon + wordmark, no subtitle (dark)
 *   /brand/logo-compact-light.svg       · icon + wordmark, no subtitle (light)
 *
 * Public serving path is /brand/ (mirrored under frontend/public/brand/).
 *
 * Props:
 *   variant   'icon-only' | 'compact' | 'full' (default 'full')
 *   onDark    render the dark-background variant
 *   size      pixel height of the rendered image
 *   className extra wrapper classes
 */
export default function Logo({ variant = "full", onDark = false, size = 72, className = "" }) {
  if (variant === "icon-only") {
    return (
      <div className={`inline-flex items-center ${className}`}>
        <img
          src="/brand/icon.svg"
          alt="ClientDesk VA"
          style={{ height: size, width: size, objectFit: "contain", display: "block" }}
        />
      </div>
    );
  }

  const src = variant === "compact"
    ? (onDark ? "/brand/logo-compact-dark.svg" : "/brand/logo-compact-light.svg")
    : (onDark ? "/brand/logo-horizontal-dark.svg" : "/brand/logo-horizontal-light.svg");

  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={src}
        alt="ClientDesk VA — Virtual Assistant Workspace"
        style={{ height: size, width: "auto", objectFit: "contain", display: "block" }}
      />
    </div>
  );
}
